<template>
    <Nav />
    <div class="container pt-3">
        <h3>Přehled firem</h3>
        <table id="firms" class="table table-bordered table-striped">
            <thead>
                <tr>
                    <th>Název firmy</th>
                    <th>ID Firmy</th>
                    <th class="text-center">Trackování</th>
                    <th class="text-center">Galerie</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(firm, index) in firms" :key="index">
                    <td>{{ firm.name }}</td>
                    <td>
                        {{ firm.firmId }}
                    </td>
                    <td class="text-center">
                        <input
                            type="checkbox"
                            id="checkbox"
                            v-model="firm.trackAccess"
                            v-on:change="UpdateFirm(firm.firmId, firm.trackAccess, firm.galleryAccess, firm.name)"
                        />
                    </td>
                    <td class="text-center">
                        <input
                            type="checkbox"
                            id="checkbox"
                            v-model="firm.galleryAccess"
                            v-on:change="UpdateFirm(firm.firmId, firm.trackAccess, firm.galleryAccess, firm.name)"
                        />
                    </td>
                    <td class="text-center">
                        <a
                            class="deleteLink"
                            href="Javascript:void(0);"
                            data-bs-toggle="modal"
                            data-bs-target="#deleteFirmModal"
                            @click="DeleteFirm(firm.firmId, firm.name)"
                        >
                            <i class="bi bi-trash"></i
                        ></a>
                    </td>
                </tr>
            </tbody>
        </table>
        <button type="button" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#newFirmModal">Přidat novou firmu</button>
    </div>
    <NewFirmModal @refresh="RefreshGrid" />
    <DeleteFirmModal @refresh="RefreshGrid" :firmId="firmId" :firmName="firmName" />
</template>

<script>
import axios from "axios";
import Nav from "../components/Nav.vue";
import NewFirmModal from "./modals/NewFirm.vue";
import DeleteFirmModal from "./modals/DeleteFirm.vue";

export default {
    name: "HomeComponent",
    data() {
        return {
            firms: [],
            firmName: "",
            trackAccessCheckBox: false,
            galleryAccessCheckBox: false,
            firmId: "",
        };
    },
    async created() {
        const response = await axios.get("http://admin.contactweb.cz/api/firms", {
            headers: {
                Authorization: "Bearer " + localStorage.getItem("token"),
            },
        });
        this.firms = response.data;
    },
    methods: {
        async DeleteFirm(firmId, name) {
            this.firmId = firmId;
            this.firmName = name;
        },

        RefreshGrid(data) {
            this.firms = data;
        },

        async UpdateFirm(firmId, trackAccess, galleryAccess, firmName) {
            await axios.put(
                "http://admin.contactweb.cz/api/firms?firmId=" + firmId + "&trackAccess=" + trackAccess + "&galleryAccess=" + galleryAccess,
                {},
                {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("token"),
                    },
                }
            );
            this.$moshaToast("Práva pro firmu " + firmName + " upravena.", { type: "success" });
        },
    },
    components: { Nav, NewFirmModal, DeleteFirmModal },
};
</script>

<style>
.deleteLink {
    color: darkred;
}

.deleteLink:hover {
    color: red;
}
</style>
